import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { StableOrganisationDTO } from "../models/stableOrganisation.model";
import { Observable } from "rxjs";
import { promise } from "protractor";

@Injectable({
  providedIn: "root"
})
export class StableOrganisationService{

  constructor(private http : HttpClient){}

  public getByCustomerID(id : number) : Promise<StableOrganisationDTO>{
    return this.http.get<StableOrganisationDTO>(environment.apiFullUrl + '/StableOrganisation/GetByCustomerID/' + id).toPromise();
  }

  public getListByCustomerID(id : number) : Observable<StableOrganisationDTO[]>{
    return this.http.get<StableOrganisationDTO[]>(environment.apiFullUrl + '/StableOrganisation/GetListByCustomerID/' + id);
  }

  public save(dto : StableOrganisationDTO) : Promise<any>{
    return this.http.post<any>(environment.apiFullUrl + '/StableOrganisation', dto).toPromise();
  }

  public delete(id : number) : Promise<any>{    
    return this.http.delete<any>(environment.apiFullUrl + '/StableOrganisation/' + id).toPromise();
  }
}
